/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TypeEnum } from './type-enum';

/**
 * SecondHand Subscription serializer in deck
 */
export interface DeckSecondhandSubscription {
  readonly id: string;
  readonly email: string;
  readonly user: string;
  readonly user_id: string | null;
  type: TypeEnum | null;
  readonly offer: string;
  readonly offer_id: string;
  readonly subscribed: boolean;
  /**
   * Auto Added Creation date
   */
  readonly created_date: string;
  readonly modified_date: string;
}
export namespace DeckSecondhandSubscription {}
